import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageUtil, LoginService } from 'ui-shared';

@Injectable({
  providedIn: 'root'
})
export class CatalogoOperacaoAuthGuard  {
  constructor(
    @Inject(Router) private router: Router,
    @Inject(LoginService) private loginService: LoginService
  ) { }

  canActivate = () => this.loginService.estaLogado() || this.router.navigateByUrl('/login')
}

